import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieConsent from "@/components/CookieConsent";
import AnnouncementBar from "@/components/AnnouncementBar";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import PazaryeriDetail from "@/pages/PazaryeriDetail";
import HowItWorks from "@/pages/HowItWorks";
import References from "@/pages/References";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Application from "@/pages/Application";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnnouncementBar />
        <Header />
        <main data-testid="site-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hizmetlerimiz" element={<Services />} />
            <Route path="/hizmetlerimiz/pazaryeri-kurulum-yonetimi" element={<PazaryeriDetail />} />
            <Route path="/hizmetlerimiz/:slug" element={<ServiceDetail />} />
            <Route path="/nasil-calisir" element={<HowItWorks />} />
            <Route path="/referanslarimiz" element={<References />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/basvuru" element={<Application />} />
            <Route path="/yasal/:slug" element={<Legal />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <CookieConsent />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#161916",
              color: "#ffffff",
              border: "1px solid rgba(0,242,46,0.25)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
